module.exports = __webpack_public_path__ + "static/media/energetic.d0b11bd9.webp";